var pagination = {
	backwardText: "pagina precedente",
	forwardText: "pagina successiva",
	pageRangeText: "Pagina {current} di {total}",
	itemsPerPageText: "Elementi per pagina",
	itemRangeText: "{start}-{end} di {total} elementi",
	pageNumberText: "pagina corrente"
};
var searchPlaceholder = "Cerca...";
var itTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { itTranslations as default, pagination, searchPlaceholder };
